import React from "react";
import {Alert, Button, FormControl, Modal} from "react-bootstrap";
import LoadingLoginScreen from "../../../components/LoadingLoginScreen";

export const AdminEditAppModal = ({version}) => {

    const [edit, setEdit] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState(false);
    const [errorText, setErrorText] = React.useState("");
    const [save, setSave] = React.useState(false);
    const [newAppVersionRef, setNewAppVersionRef] = React.useState(0);

    const handleEditApp = async () => {
        setLoading(true);
        if (newAppVersionRef === 0) {
            setError(true);
            setErrorText("Ange en version större än 0")
            setLoading(false);
            return;
        } else if (newAppVersionRef === version) {
            setError(true);
            setErrorText("Kan ej uppdatera till samma version som är aktuell")
            setLoading(false);
            return;
        } else {
            setLoading(true);
            // await updateAppVersion(newAppVersionRef);
        }

    }

    return (
        <>

            <Button variant="success" onClick={() => setEdit(!edit)}>
                Redigera App
            </Button>

            <Modal show={edit} onHide={() => setEdit(!edit)}>
                <Modal.Header>
                    <Modal.Title>Redigera App</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {loading ? <LoadingLoginScreen/> : null}

                    {error ? <Alert variant={"success"}>{errorText}</Alert> : null}
                    Nuvarande version: {version}
                    <hr/>
                    Uppdatera version
                    <input
                        type={"number"}
                        onChange={(e) => setNewAppVersionRef(e.target.value)}
                    />
                </Modal.Body>
                <Modal.Footer>

                    <Button variant="secondary" disabled={loading} onClick={() => setEdit(false)}>
                        Stäng
                    </Button>
                    {save ? <Button variant="primary" disabled={loading} onClick={handleEditApp}>
                            Godkänn Version: <b>{newAppVersionRef}</b>
                        </Button> :
                        <Button variant="primary" disabled={loading} onClick={() => setSave(!save)}>
                            Spara
                        </Button>}


                </Modal.Footer>
            </Modal>


        </>
    )
}
